import { adminPanelTranslation } from '@/assets/locales/views/adminPanel/adminPanel.translation.en.ts';
import {
  areaTranslation,
  AreaTranslation,
} from '@/assets/locales/views/area/area.translation.en.ts';
import {
  certificationTranslation,
  CertificationTranslation,
} from '@/assets/locales/views/certification/certification.translation.en.ts';
import {
  contactTranslation,
  ContactTranslation,
} from '@/assets/locales/views/contact/contact.translation.en.ts';
import { employeeProfileTranslation } from '@/assets/locales/views/employeeProfile/employeeProfile.translation.en.ts';
import { EmployeeProfileTranslation } from '@/assets/locales/views/employeeProfile/employeeProfile.translation.pl.ts';
import {
  employeeProfilesListTranslation,
  EmployeeProfilesListTranslation,
} from '@/assets/locales/views/employeeProfilesList/employeeProfilesSearch.translation.en.ts';
import {
  examineeExamTranslation,
  ExamineeExamTranslation,
} from '@/assets/locales/views/examineeExam/examineeExam.translation.en.ts';
import {
  landingPageTranslation,
  LandingPageTranslation,
} from '@/assets/locales/views/landingPage/landingPage.translation.en.ts';
import {
  maintenancePageTranslation,
  MaintenancePageTranslation,
} from '@/assets/locales/views/MaintenancePage/MaintenancePage.translation.en.ts';
import {
  myProfileTranslation,
  MyProfileTranslation,
} from '@/assets/locales/views/myProfile/myProfile.translation.en.ts';
import { nestedStructureTranslation } from '@/assets/locales/views/nestedStructure/nestedStructure.translation.en.ts';
import {
  notificationsTranslation,
  NotificationsTranslation,
} from '@/assets/locales/views/notifications/notifications.translation.en.ts';
import { organizationChartTranslation } from '@/assets/locales/views/organizationChart/organizationChart.translation.en.ts';
import {
  practicalExamShareTranslation,
  PracticalExamShareTranslation,
} from '@/assets/locales/views/practicalExamShare/practicalExamShare.translation.en.ts';
import {
  successionTranslation,
  SuccessionTranslation,
} from '@/assets/locales/views/succession/succession.translation.en.ts';
import {
  surveyFillTranslation,
  SurveyFillTranslation,
} from '@/assets/locales/views/surveyFill/surveyFill.translation.en.ts';
import {
  teamTranslation,
  TeamTranslation,
} from '@/assets/locales/views/team/team.translation.en.ts';
import {
  testFillTranslation,
  TestFillTranslation,
} from '@/assets/locales/views/testFill/testFill.translation.en.ts';
import {
  uploadEmployeesTranslation,
  UploadEmployeesTranslation,
} from '@/assets/locales/views/uploadEmployees/uploadEmployees.translation.en.ts';
import { uploadsHistoryTranslation } from '@/assets/locales/views/uploadsHistory/uploadsHistory.translation.en.ts';
import { UploadsHistoryTranslation } from '@/assets/locales/views/uploadsHistory/uploadsHistory.translation.pl.ts';
import {
  usersListTranslation,
  UsersListTranslation,
} from '@/assets/locales/views/usersList/usersList.translation.en.ts';

export type ViewsTranslation = {
  adminPanel: typeof adminPanelTranslation;
  area: AreaTranslation;
  certification: CertificationTranslation;
  contact: ContactTranslation;
  employeeProfile: EmployeeProfileTranslation;
  employeeProfilesList: EmployeeProfilesListTranslation;
  examineeExam: ExamineeExamTranslation;
  landingPage: LandingPageTranslation;
  maintenancePage: MaintenancePageTranslation;
  myProfile: MyProfileTranslation;
  nestedStructure: typeof nestedStructureTranslation;
  notifications: NotificationsTranslation;
  organizationChart: typeof organizationChartTranslation;
  practicalExamShare: PracticalExamShareTranslation;
  succession: SuccessionTranslation;
  surveyFill: SurveyFillTranslation;
  team: TeamTranslation;
  testFill: TestFillTranslation;
  uploadEmployees: UploadEmployeesTranslation;
  uploadsHistory: UploadsHistoryTranslation;
  usersList: UsersListTranslation;
};

export const viewsTranslation: ViewsTranslation = {
  adminPanel: adminPanelTranslation,
  area: areaTranslation,
  certification: certificationTranslation,
  contact: contactTranslation,
  employeeProfile: employeeProfileTranslation,
  employeeProfilesList: employeeProfilesListTranslation,
  examineeExam: examineeExamTranslation,
  landingPage: landingPageTranslation,
  maintenancePage: maintenancePageTranslation,
  myProfile: myProfileTranslation,
  nestedStructure: nestedStructureTranslation,
  notifications: notificationsTranslation,
  organizationChart: organizationChartTranslation,
  practicalExamShare: practicalExamShareTranslation,
  succession: successionTranslation,
  surveyFill: surveyFillTranslation,
  team: teamTranslation,
  testFill: testFillTranslation,
  uploadEmployees: uploadEmployeesTranslation,
  uploadsHistory: uploadsHistoryTranslation,
  usersList: usersListTranslation,
};
